import { render, staticRenderFns } from "./ShowcaseCard.vue?vue&type=template&id=3d3815bc&scoped=true"
import script from "./ShowcaseCard.vue?vue&type=script&lang=js"
export * from "./ShowcaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3815bc",
  null
  
)

export default component.exports